// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3GLvM","list":"PatternAutocomplete_list__p49qe"};